module.exports = __webpack_public_path__ + "static/media/houseRegular.360b0234.svg";